export enum PRODUCT_TYPE {
    CLOTHING = 'clothing',
    BICYCLE = 'bicycle',
    MEMBERSHIP = 'membership',
    PERSONAL_TRAINING = 'personalTraining',
    NUTRITION = 'nutrition'
}
